import Backbone from 'backbone';
import $ from 'jquery';
import ko from 'knockout';
import _ from 'underscore';
import ReactDOM from 'react-dom';

import {
  withContextualAttributeTemplate,
  showContextualAttribute,
  hideContextualAttribute,
  prependAccountAttribute,
} from '@bingads-webui-campaign/recommendation-contextual-attribute';
import {
  APPLY_USERINPUT_TYPES,
  CONTEXTUAL_ENTITY_TYPE,
  RECOMMENDATION_TYPES,
  CAMPAIGN_ODATA_ERROR_BASELINE,
  formatCampaignBulkApiError,
} from '@bingads-webui-campaign/recommendation-core';
import template from './new-ads-preview.pug';
import ViewModel from './new-ads-preview-model';
import AdsEditorContainer from './ads-editor-container';
import {
  adTypeMapping,
  adTypeFieldsMapping,
  descriptionHeaderMapping,
  transformResponsiveSearchAd,
  transformMultimediaAd,
  transformImproveResponsiveSearchAd,
  transformImproveMultimediaAd
} from './const';

export default class NewAdsInlineView extends Backbone.View {
  initialize({
    deps = {
      adDisplayUrlService: null,
      combineText: null,
      permissions: {
        IsRecommendationRepairSuggestedAdsEnabled: true,
        IsRecommendationRSAMMAPnaelEditEnabled: true,
      },
    },
    data = {},
    i18n,
    newI18n,
    router,
    type,
    isMCC,
    gridView,
    readOnly,
    gridService,
    applyAction = null,
  }) {
    this.deps = deps;
    this.data = _.first(data.Opportunities);
    this.i18n = i18n;
    this.newI18n = newI18n;
    this.router = router;
    this.isMCC = isMCC;
    this.grid = { gridView };
    this.ko_model = new ViewModel({ data: this.data, type });
    this.adsEditorContainerView = {};
    this.gridService = gridService;
    this.isPanelEdit = this.deps.permissions.IsRecommendationRSAMMAPnaelEditEnabled
      || type === RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS
      || type === RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS;
    this.applyAction = applyAction;
    this.type = type;
    this.readOnly = readOnly;
    this.adType = adTypeMapping[type];
    this.adEditorFields = adTypeFieldsMapping[type];
    this.descriptionHeader = descriptionHeaderMapping[type];
  }

  get events() {
    return {
      'click .btn-hero.apply': 'apply',
      'click .btn-cancel': 'closeInlineView',
      'click .error-message .close': 'dismissMessage',
      'mouseover .recommendation-new-ads-inline-view .contextual-tooltip': 'showContextualAttributePopup',
      'mouseout .recommendation-new-ads-inline-view .contextual-tooltip': 'hideContextualAttributePopup',
      'click .recommendation-new-ads-inline-view .contextual-tooltip': 'scopeRouting',
    };
  }

  scopeRouting(e) {
    if (this.isPanelEdit) {
      this.trigger('cancel');
    }
    this.router(e, this.data);
  }

  hideContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    hideContextualAttribute({ e, self: this });
  }

  showContextualAttributePopup(e) {
    clearTimeout(this.timerForPopupContextualAttribute);
    this.timerForPopupContextualAttribute = setTimeout(() => {
      showContextualAttribute({
        deps: this.deps,
        i18n: this.i18n,
        e,
        type: this.data.OpportunityType,
        isExpanding: !this.isPanelEdit,
        self: this,
        recommendationService: this.gridService.recommendationService,
      });
    }, 500);
  }

  render() {
    const params = _.extend(this.ko_model, {
      i18n: this.i18n,
      getEntity: this.getEntity,
      descriptionHeader: this.descriptionHeader,
      readOnly: this.readOnly,
      isPanelEdit: this.isPanelEdit,
    });

    this.$el.html($(template(params)));
    ko.applyBindings(this.ko_model, this.$el[0]);
    this.delegateEvents();

    this.$('.simple-view-edit-mode').addClass('no-new-ads');

    this.adsEditor(this.ko_model.currentAdModel());

    return this;
  }

  dealWithInlineError(errors) {
    if (_.isUndefined(errors) || errors.length === 0) {
      return;
    }
    if (this.type === RECOMMENDATION_TYPES.MULTIMEDIA_ADS
      || this.type === RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS) {
      const { adTypeViews } = this.adsEditorContainerView.adEditor;
      const crudAudienceAdReact = adTypeViews.Responsive.audienceAd.crudReactComponent.current;
      crudAudienceAdReact.setResponseErrors(formatCampaignBulkApiError(
        errors,
        CAMPAIGN_ODATA_ERROR_BASELINE
      ));
    }
  }

  hasInlineError(errors) {
    return errors.length === 1 && errors[0].ErrorCode >= CAMPAIGN_ODATA_ERROR_BASELINE;
  }

  hasChanged() {
    return this.adsEditorContainerView &&
      this.adsEditorContainerView.hasChanged &&
      this.adsEditorContainerView.hasChanged(this.adEditorFields);
  }

  apply() {
    const { type } = this;
    const { adTypeViews } = this.adsEditorContainerView.adEditor;
    let context = {};
    let updatedAdView;
    let updatedAd;
    switch (type) {
      case RECOMMENDATION_TYPES.DYNAMIC_SEARCH_ADS:
        updatedAdView = adTypeViews.DynamicSearch;
        // [TODO] Need to determine the Ad structure of Dynamic search ads
        break;
      case RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS: {
        updatedAdView = adTypeViews.ResponsiveSearch;
        const returnIds =
          updatedAdView.adStrengthContainer.options.viewModel.returnSuggestionIds;
        const viewIds =
          updatedAdView.adStrengthContainer.options.viewModel.viewSuggestionIds;
        const applyIds =
          updatedAdView.adStrengthContainer.options.viewModel.applySuggestionIds;
        const clickIdeas =
          updatedAdView.adStrengthContainer.options.viewModel.clickViewIdeas;
        // When returnSuggestionIds is not empty, it means users has received asset suggestions.
        // When viewSuggestionIds is empty, it means users don't visit any RSA asset suggestions.
        // When applySuggestionIds is empty, it means users don't adopt any asset suggestion.
        if (!_.isEmpty(returnIds)) {
          context = {
            AcceptInfo: {
              ReturnSuggestionIds: returnIds,
              ViewSuggestionIds: viewIds || [],
              ApplySuggestionIds: applyIds || [],
              ClickViewIdeas: clickIdeas || [],
            },
          };
        }
        updatedAd = {
          NewAd: transformResponsiveSearchAd(_.pick(
            updatedAdView.toObject(),
            this.adEditorFields
          )),
        };
        break;
      }
      case RECOMMENDATION_TYPES.MULTIMEDIA_ADS: {
        updatedAdView = adTypeViews.Responsive;
        const crudAudienceAdReact = updatedAdView.audienceAd.crudReactComponent.current;
        const initialParams = crudAudienceAdReact.getData();

        // Input data in image extension editor is not valid
        if (!crudAudienceAdReact.isDataValid(initialParams)) {
          return;
        }

        // The option "Allow Microsoft to use images from ..." is showed and it's not checked.
        const adExtensionViewModel = crudAudienceAdReact.adEditRef.current.view.viewModel;
        if (adExtensionViewModel.showWebsiteImageOptIn()
          && adExtensionViewModel.hasWebsiteImageOptIn() !== true) {
          return;
        }

        crudAudienceAdReact.getProcessedDataAsync(initialParams)
          .then((result) => {
            const params = result.mtModel;
            const recommendedImageAssetIdStrings =
                _.unique(_.map(this.data.Images, image => (image.ImageAssetIdString)));
            updatedAd = {
              NewAd: transformMultimediaAd(_.pick(
                params,
                this.adEditorFields
              ), recommendedImageAssetIdStrings, this.ko_model.imageFeatureMaskMap),
            };
            this.applyRecommendation(updatedAd, context);
          });
        break;
      }
      case RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS: {
        updatedAdView = adTypeViews.ResponsiveSearch;
        updatedAd = {
          SuggestedAssets: transformImproveResponsiveSearchAd(_.pick(
            updatedAdView.toObject(),
            this.adEditorFields
          )),
        };
        break;
      }
      case RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS: {
        updatedAdView = adTypeViews.Responsive;
        const crudAudienceAdReact = updatedAdView.audienceAd.crudReactComponent.current;
        const initialParams = crudAudienceAdReact.getData();

        // Input data in image extension editor is not valid
        if (!crudAudienceAdReact.isDataValid(initialParams)) {
          return;
        }

        // The option "Allow Microsoft to use images from ..." is showed and it's not checked.
        const adExtensionViewModel = crudAudienceAdReact.adEditRef.current.view.viewModel;
        if (adExtensionViewModel.showWebsiteImageOptIn()
          && adExtensionViewModel.hasWebsiteImageOptIn() !== true) {
          return;
        }

        crudAudienceAdReact.getProcessedDataAsync(initialParams)
          .then((result) => {
            const params = result.mtModel;
            updatedAd = {
              SuggestedAssets: transformImproveMultimediaAd(_.pick(
                params,
                this.adEditorFields
              )),
            };
            this.applyRecommendation(updatedAd, context);
          });
        break;
      }
      default:
        throw new Error(`Not Implemented: ${type}`);
    }

    if (type !== RECOMMENDATION_TYPES.MULTIMEDIA_ADS
      && type !== RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS) {
      if (!updatedAdView.validate()) {
        return;
      }
      this.applyRecommendation(updatedAd, context);
    }
  }

  getEntity = () => {
    const entity = this.data.Target.AdGroupName ?
      `${withContextualAttributeTemplate({
        opportunityId: this.data.OpportunityId,
        entityName: this.data.Target.CampaignName,
        entityId: this.data.Target.CampaignId,
        entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
        status: 'false',
        isExpandingView: true,
        ariaLabel: this.i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: this.data.Target.CampaignName }),
      })} > ${withContextualAttributeTemplate({
        opportunityId: this.data.OpportunityId,
        entityName: this.data.Target.AdGroupName,
        entityId: this.data.Target.AdGroupId,
        entityType: CONTEXTUAL_ENTITY_TYPE.ADGROUP,
        entityCampaignId: this.data.Target.CampaignId,
        status: 'false',
        isExpandingView: true,
        ariaLabel: this.i18n.getString('Click to scope to ad group {{adGroupName}}', { adGroupName: this.data.Target.AdGroupName }),
      })}` :
      withContextualAttributeTemplate({
        opportunityId: this.data.OpportunityId,
        entityName: this.data.Target.CampaignName,
        entityId: this.data.Target.CampaignId,
        entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
        status: 'false',
        isExpandingView: true,
        ariaLabel: this.i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: this.data.Target.CampaignName }),
      });
    return {
      entity_name: this.isMCC ? prependAccountAttribute({
        opportunityId: this.data.OpportunityId,
        accountId: this.data.Target.AccountId,
        accountName: this.data.Target.AccountName,
        originEntity: entity,
      }) : entity,
    };
  };

  closeInlineView(e) {
    const container = $('body');
    // Hide AdStrengthSuggestionPicker
    const adStrengthSuggestionPicker = container.find('.ad-strength-suggestion-container');
    if (!_.isEmpty(adStrengthSuggestionPicker) && adStrengthSuggestionPicker.length === 1) {
      ReactDOM.unmountComponentAtNode(_.first(adStrengthSuggestionPicker));
    }

    // Hide AdCustomizerPicker
    const adCustomizerPicker = container.find('.ad-customizer-container');
    if (!_.isEmpty(adCustomizerPicker) && adCustomizerPicker.length === 1) {
      ReactDOM.unmountComponentAtNode(_.first(adCustomizerPicker));
    }
    e.stopImmediatePropagation();
    this.remove();
    this.trigger('cancel');
  }

  adsEditor(data) {
    const {
      adType, deps, i18n, type, newI18n,
    } = this;

    const inlineSuggestionsEnabled =
      type === RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS;

    const showLightbulb = deps.permissions.IsRSAAdoptionV2Enabled;

    const adEditorModel = data;

    ko.cleanNode(this.$('.new-ad-editor-container')[0]);

    if (this.adsEditorContainerView && this.adsEditorContainerView.off) {
      this.adsEditorContainerView.off('updated');
    }

    this.adsEditorContainerView = new AdsEditorContainer({
      deps,
      i18n,
      newI18n,
      model: _.extend(adEditorModel, { Type: adType }),
      accountId: this.data.Target.AccountId,
      campaignId: this.data.Target.CampaignId,
      adGroupId: this.data.Target.AdGroupId,
      inlineSuggestionsEnabled,
      showLightbulb,
      type: this.type,
    });

    this.$('.new-ad-editor-container').html(this.adsEditorContainerView.render().el);
  }

  applyRecommendation(updatedAd, context) {
    const basicInput = {
      '@odata.type': APPLY_USERINPUT_TYPES[this.data.OpportunityType],
      OpportunityId: this.data.OpportunityId,
    };
    if (this.isPanelEdit) {
      this.applyAction([this.data], [_.extend(basicInput, updatedAd)], context);
    } else {
      this.trigger(
        'apply',
        {
          opportunities: [this.data],
          userInputs: [_.extend(basicInput, updatedAd)],
          context,
        }
      );

      // scroll to top to see feedbacks
      $('html, body').scrollTop(0);
    }
  }
}
